import React, { useState } from "react";
import "./style.css"
import { Input , Button, Box } from "@mantine/core";
import { FiPlus } from "react-icons/fi";
import { DatePickerInput } from "@mantine/dates";

const   SkypointInvoiceItemTable = ({rows,setRows,isPreview, dateRangeVal,setDateRangeVal}) => {

  const addRow = (e) => {
    e.preventDefault(); // Prevent page refresh
    setRows([...rows, { name: "", quantity: 1, amount: 0 }]);
  };


  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index
        ? {
            ...row,
            [field]: field === "quantity" || field === "amount" ? +value : value,
          }
        : row
    );
    setRows(updatedRows);
  };

  const calculateTotal = () =>
    rows.reduce((total, row) => total + row.quantity * row.amount, 0);

    const handleDateRange = (dates) => {

      if (dates[0] == null && dates[1] == null) {
        setDateRangeVal([]);
      } else {
        setDateRangeVal(dates);
      }
    };

  return (
    <div className="invoice-container">
      <table className="invoice-table">
        <thead>
          <tr>
            <th className="invoice-table-header-top">Item Table</th>
            <th className="invoice-table-header-top"></th>
            <th className="invoice-table-header-top"></th>
                <th className="invoice-table-header-top">Date Of service
                          <Box>
                    
                            <DatePickerInput
                            className="datepicker"
                              //  onClick={handleCalendarOpen}
                               
                              size="md"
                                        clearable
                            
                                        // m={".5rem"}
                                        icon={
                                          <img
                                            style={{ width: "20px" }}
                                            src={"/assets/images/billingcalendar.png"}
                                            alt="Icon"
                                          />
                                        }
                                        sx={{
                                          "& .mantine-15cfudd": {
                                            border: "none",
                                          },
                                       
                        
                                          "& .mantine-1d4lrir": {
                                            border: "none !important",
                                        
                                          }
                                        }}
                                        
                                        type="range"
                                        value={dateRangeVal}
                                        disabled={isPreview}
                                        // label="Select Date Range"
                                        onChange={handleDateRange}
                                        placeholder="Select Date Range"
                                      />
                           
                              </Box>
                                    </th>
            <th className="invoice-table-header-top"></th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th className="invoice-table-header">Item Details</th>
            <th className="invoice-table-header">Quantity</th>
            <th className="invoice-table-header">Amount</th>
            <th className="invoice-table-header">Action</th>
            <th className="invoice-table-header"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="invoice-table-row">
              <td  style={{width:'50%'}}  className="invoice-table-cell">
                <Input
                  type="text"
                  value={row.name}
                  placeholder="Enter name"
                  style={{width:'100%'}}
                  onChange={(e) =>
                    handleInputChange(index, "name", e.target.value)
                  }
                  className="invoice-input"
                  disabled={isPreview}
                />
              </td>
              <td className="invoice-table-cell">
                <Input
                   type="number"
                  placeholder="Enter Quantity"
                  width={20}
                  // min="1"
                  style={{width:'100%'}}
                  value={row.quantity}
                  onChange={(e) =>
                    handleInputChange(index, "quantity", e.target.value)
                  }
                  className="invoice-input quantity-input"
                  disabled={isPreview}
                />
              </td>
              <td className="invoice-table-cell">
                <Input
                   type="number"
                  // min="0"
                  style={{width:'100%'}}
                  // width={10}
                  value={row.amount}
                  onChange={(e) =>
                    handleInputChange(index, "amount", e.target.value)
                  }
                  className="invoice-input amount-input"
                  disabled={isPreview}
                />
              </td>
              <td style={{width:'15%',padding:8}} className="invoice-table-cell">
                <Button
                  style={{width:'100%',background:'#FEF3F2',color:'#B42318'}}
                  className="invoice-input amount-input"
                  disabled={isPreview}
                  onClick={() => removeRow(index)}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="invoice-upper-footer">
          <button onClick={addRow} className="add-items-btn">
            <FiPlus size={25} />
            <span>Add Items</span>
          </button>
      </div>
      <div className="invoice-footer">
        <div className="total-amount">
          Total Amount:
        </div>
 
        <div className="total-amount" style={{fontWeight:'normal'}}>
          ${calculateTotal().toFixed(2)}
        </div>
      </div>
    </div>
  );
};

export default SkypointInvoiceItemTable;
